import UiService from "../../core/helpers/ui-service.helper";
import { PayPalConfirmationViewModel } from "./paypal-confirmation.vm";

export const PayPalConfirmationInitialiser = () => {
  ko.applyBindings(new PayPalConfirmationViewModel(), document.body);

  $(() => {
      UiService.ApplyCartPosition('#my-cart', '#confirm-container');
  });
  
  $(window).on('scroll',  () => {
      UiService.ApplyCartPosition('#my-cart', '#confirm-container');
  });
  $(window).on('resize', () => {
      UiService.ApplyCartPosition('#my-cart', '#confirm-container');
  });
  
}